module.exports = __webpack_public_path__ + "img/welcome_10.e28c1b0f.jpg";